import React from 'react'
import { Row, Col } from '@microfrontends/react-components'
import {
	ContactContainer,
	SocialContact,
	Link,
	BreakLine,
	ContactSection, ContactWrapper,
} from './styles'
import {ContentContainer} from '../styles';
import PageTitle from '../../components/PageTitle';
import {FacebookIcon, LinkedInIcon, SpotifyIcon, TiktokIcon} from '../../assets/icons';
import {assetUrl} from '../index';

export default function Contact() {
	return (
		<ContentContainer narrowedWidth>
			<PageTitle>
				Về Vietnamworks
			</PageTitle>
			<ContactWrapper>
				<div>
					<p>
						VietnamWorks trực thuộc tập đoàn Navigos Group -
						là website tìm kiếm việc làm số 1 Việt Nam. Tính
						đến năm 2023, VietnamWorks đã tròn{' '}
						<strong>21 năm hoạt động</strong>, với hơn&nbsp;
						<strong>
							9 triệu lượt truy cập
						</strong> hàng tháng.
					</p>
					<p>
						VietnamWorks đã mang đến cơ hội công việc mới
						cho hơn <strong>5 triệu</strong> ứng viên và
						đồng hành cùng&nbsp;
						<strong>60.000 doanh nghiệp</strong> hàng đầu
						tại Việt Nam cùng các tập đoàn đa quốc gia.
					</p>
				</div>
				<div className="contact">
					<img src={assetUrl('contact_us.png')}/>
					<div className="contact-info">
						<div className="social-icons">
							<a
								href='https://www.facebook.com/VietnamWorksFanpage'
								target='_blank'
							>
								<FacebookIcon />
							</a>
							<a
								href='https://www.linkedin.com/company/vietnamworks/'
								target='_blank'
							>
								<LinkedInIcon />
							</a>
							<a
								href='https://www.tiktok.com/@vietnamworks_official'
								target='_blank'
							>
								<TiktokIcon />
							</a>
							<a
								href='https://open.spotify.com/show/0gSEWFjuimEuxzAY0M0mjc'
								target='_blank'
							>
								<SpotifyIcon />
							</a>
						</div>
						<div className="address">
							<span><strong>Tầng 20 Tòa nhà e.town Central,</strong></span><br/>
							<span>11 Đoàn Văn Bơ - phường 13 - Quận 4 -
								TP Hồ Chí Minh</span>
						</div>
					</div>
				</div>
			</ContactWrapper>
		</ContentContainer>
	)
}
